<template>
  <div id="articlesListPage">
    <NavBar :active="isOnline" class="overflow-y-hidden"/>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
    <v-main class="overflow-hidden">
      <BackBar :title="'مقاله ها'"/>
      <ContentsList :dataLoading="dataLoading" :items="articlesList"/>
    </v-main>
      </div>
    </div>
  </div>
</template>

<script>
import ContentsList from "@/components/ContentsList";
import BackBar from "@/components/BackBar";
import NavBar from "@/components/NavBar";

export default {
  name: "ArticlesList",
  metaInfo: {
    title: 'ایوان خانه- مقالات',
  },
  components: {NavBar, BackBar, ContentsList},
  data: () => ({
    articlesList: [],
    dataLoading: true,
    isOnline: null,
    TypeExtraExtension: null,

  }),
  mounted() {

    if (this.$route.query.isOnline === 'true') {
      this.isOnline = 'online'
      this.TypeExtraExtension = 1
    } else {
      this.isOnline = 'offline'
      this.TypeExtraExtension = 2
    }
    this.getData()
  },
  methods: {
    getData() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      fetch(this.$baseUrl + "Publicly/ListExtraExtension?TypeExtraExtension=" + this.TypeExtraExtension + "&TypeDefineExtraExtension=2", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.articlesList = json.list.filter(x => x.IsActive === true)
            this.dataLoading = false
          })
          .catch(error => console.log('error', error));

    }
  }
}
</script>
